import React from 'react';
import { Box, Container } from '@mui/material';
import UserSettings from '../components/settings/UserSettings';

function Settings() {
  return (
    <Box>
      <Container maxWidth="lg" sx={{ mt: 0 }}>
        <UserSettings />
      </Container>
    </Box>
  );
}

export default Settings;
